"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = _styledComponents.default.circle.withConfig({
  displayName: "Circle",
  componentId: "sc-13jfr4w-0"
})(["stroke:", ";transition:stroke-dashoffset 0.35s;transform:rotate(-90deg);transform-origin:50% 50%;"], function (_ref) {
  var stroke = _ref.stroke;
  return (0, _helpers.color)(stroke);
});

var Bar = _styledComponents.default.circle.withConfig({
  displayName: "Bar",
  componentId: "sc-13jfr4w-1"
})(["stroke:", ";"], function (_ref2) {
  var stroke = _ref2.stroke;
  return (0, _helpers.color)(stroke);
});

var Svg = _styledComponents.default.svg.withConfig({
  displayName: "Svg",
  componentId: "sc-13jfr4w-2"
})(["width:1em;height:1em;"]);

var ProgressSpinner = function ProgressSpinner(_ref3) {
  var _ref3$radius = _ref3.radius,
      radius = _ref3$radius === void 0 ? 40 : _ref3$radius,
      _ref3$stroke = _ref3.stroke,
      stroke = _ref3$stroke === void 0 ? 16 : _ref3$stroke,
      _ref3$progress = _ref3.progress,
      progress = _ref3$progress === void 0 ? 0 : _ref3$progress,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? 'dark-1' : _ref3$color,
      _ref3$barColor = _ref3.barColor,
      barColor = _ref3$barColor === void 0 ? 'dark-3' : _ref3$barColor;
  var normalizedRadius = radius - stroke / 2;
  var circumference = normalizedRadius * 2 * Math.PI;
  var strokeDashoffset = circumference - progress * circumference;
  return _react.default.createElement(Svg, {
    viewBox: "0 0 ".concat(radius * 2, " ").concat(radius * 2)
  }, _react.default.createElement(Bar, {
    stroke: barColor,
    fill: "transparent",
    strokeWidth: stroke,
    r: normalizedRadius,
    cx: radius,
    cy: radius,
    strokeDashoffset: strokeDashoffset
  }), _react.default.createElement(Circle, {
    stroke: color,
    fill: "transparent",
    strokeWidth: stroke,
    strokeDasharray: "".concat(circumference, " ").concat(circumference),
    style: {
      strokeDashoffset: strokeDashoffset
    },
    r: normalizedRadius,
    cx: radius,
    cy: radius
  }));
};

var _default = (0, _styledComponents.default)(ProgressSpinner).withConfig({
  componentId: "sc-13jfr4w-3"
})(["margin:auto;"]);

exports.default = _default;